import React from "react";
import treeData from "./treeData";
import TreeMaker from "./TreeMaker/TreeMaker";
const TaskTree = () => <TreeMaker treeData={treeData} />;

export default TaskTree;
